import { StatsigUser } from "statsig-node";
import { nanoid } from "nanoid";
import { Utils } from "../Utils";
import Cookies from "js-cookie";
import { PublicSettings } from "../config/PublicSettings";

export class StatsigUtils {
    static getStatsigUser({
        searchParams,
        cookieID,
        userID,
        initialCustom
    }: {
        searchParams: Record<string, string>;
        cookieID?: string;
        userID?: string;
        initialCustom?: StatsigUser["custom"];
    }): StatsigUser {
        const testUserIdFromParams = Utils.getQueryParameter("tuid");

        let finalUserID: string;
        let isNewTUID: boolean;

        if (testUserIdFromParams) {
            finalUserID = testUserIdFromParams;
            isNewTUID = false;
            // ENG-17896: persist a URL-provided tuid so the identity survives
            // the homepage -> quote-funnel hop via the shared apex cookie
            // (spot-web deliberately strips tuid from forwarded query strings).
            if (testUserIdFromParams !== Cookies.get("tuid")) {
                Cookies.set("tuid", testUserIdFromParams, {
                    path: "/",
                    domain: PublicSettings.COOKIE_DOMAIN,
                    secure: !PublicSettings.COOKIE_DOMAIN.includes("localhost"),
                    sameSite: "Lax"
                });
            }
        } else if (userID) {
            finalUserID = userID;
            isNewTUID = false;
        } else if (cookieID) {
            finalUserID = cookieID;
            isNewTUID = false;
        } else {
            finalUserID = nanoid();
            isNewTUID = true;
            Cookies.set("tuid", finalUserID, {
                path: "/",
                domain: PublicSettings.COOKIE_DOMAIN,
                secure: !PublicSettings.COOKIE_DOMAIN.includes("localhost"),
                sameSite: "Lax"
            });
        }

        const custom: Record<string, string> = {};
        Object.entries(searchParams).forEach(([key, value]) => {
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const lastValue = value[value.length - 1];
                    if (lastValue !== undefined) {
                        custom[`query_${key}`] = lastValue;
                    }
                } else {
                    custom[`query_${key}`] = value;
                }
            }
        });

        return {
            userID: finalUserID,
            custom: {
                ...initialCustom,
                ...custom,
                isNewTUID
            }
        };
    }
}
